<template>
  <button
    class="inline-flex flex-row items-center gap-xs rounded-[4px] bg-avtalat-teal px-xs py-2xs type-body-sm text-white hover:bg-[--teal-900]"
    v-on:click.prevent="$emit('remove')"
    v-if="removable"
  >
    <span class="leading-normal"><slot></slot></span
    ><font-awesome-icon icon="fa-regular fa-xmark" size="xs" />
  </button>
  <span
    class="inline-flex cursor-default flex-row items-center gap-xs rounded-[4px] bg-avtalat-teal px-xs py-2xs type-body-sm text-white"
    v-else
  >
    <span class="leading-normal"><slot></slot></span>
  </span>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

type ChipsItemProps = {
  removable?: boolean;
};

defineProps<ChipsItemProps>();

library.add(faXmark);
</script>
